import { jsx as _jsx } from "react/jsx-runtime";
import { MatchStatsForm, } from "./MatchStatsForm";
import { findPlayerIntraSquadMatchStatByPlayerId } from "./utils";
export const IntraSquadMatchStatsForm = ({ intraSquadMatch, onSubmit, teamPreferences, }) => {
    const getPlayerIntraSquadMatchStat = findPlayerIntraSquadMatchStatByPlayerId(intraSquadMatch?.playerIntraSquadMatchStats || []);
    const teamAPlayers = intraSquadMatch.teamAPlayers;
    const teamBPlayers = intraSquadMatch.teamBPlayers;
    const initialPlayerStats = [
        ...teamAPlayers,
        ...teamBPlayers,
    ].map((player) => {
        const playerIntraSquadMatchStat = getPlayerIntraSquadMatchStat(player.id);
        return {
            teamId: intraSquadMatch.team,
            playerId: player.id,
            goalsScored: playerIntraSquadMatchStat?.goalsScored,
            yellowCards: playerIntraSquadMatchStat?.yellowCards,
            redCards: playerIntraSquadMatchStat?.redCards,
            id: playerIntraSquadMatchStat?.id,
        };
    });
    const handleSubmit = (result, playerStats) => {
        const intraSquadMatchResult = {
            id: intraSquadMatch.intraSquadMatchResult?.id,
            intraSquadMatchId: intraSquadMatch.id,
            teamAScore: result.leftTeamScore,
            teamBScore: result.rightTeamScore,
            matchReport: result.matchReport,
        };
        const playerIntraSquadMatchStats = playerStats.map((stat) => ({
            id: stat.id,
            playerId: stat.playerId,
            teamId: stat.teamId,
            goalsScored: stat.goalsScored,
            yellowCards: stat.yellowCards,
            redCards: stat.redCards,
            intraSquadMatchId: intraSquadMatch.id,
        }));
        onSubmit(intraSquadMatchResult, playerIntraSquadMatchStats);
    };
    return (_jsx(MatchStatsForm, { leftTeamName: teamPreferences.teamAName || "Team A", rightTeamName: teamPreferences.teamBName || "Team B", leftTeamPlayers: teamAPlayers, rightTeamPlayers: teamBPlayers, initialLeftScore: intraSquadMatch.intraSquadMatchResult?.teamAScore, initialRightScore: intraSquadMatch.intraSquadMatchResult?.teamBScore, initialMatchReport: intraSquadMatch.intraSquadMatchResult?.matchReport, showMatchReport: true, initialPlayerStats: initialPlayerStats, onSubmit: handleSubmit }));
};
